export default "__VITE_ASSET__CBI1Pusd__"